import { Security } from '@blk/awt-aladdinportfoliobuilderserver';
import { CancelToken } from 'axios';
import { apbApi } from './Base';

type AttributionSummary = {
  [cusip: string]: number;
};

export type AttributionPeriod = {
  errors?: string[];
  attributionSummary: AttributionSummary;
  success: boolean;
  totalReturn: number;
};

export interface MPAttribution {
  attributionOutput: {
    [portKey: string]: {
      date: string;
      portKey: string;
      attributionSummaries: {
        [period: string]: AttributionPeriod;
      };
    };
  };
  securityMap: { [cusip: string]: Security };
}

export async function postMultiPeriodAttributionForDeepDive(
  {
    monthsLookback,
    accountSnapShots,
    analysisDate,
    accountID,
  }: {
    monthsLookback: number;
    accountSnapShots: AccountSnapShot[][];
    analysisDate?: string;
    accountID?: string | null;
  },
  cancelToken?: CancelToken
) {
  const ERR_MSG = `Error calculating multi-period attribution for portfolio ${accountID}`;

  const path = 'attribution/multiple-account';
  try {
    const response = await apbApi.post<MPAttribution>(path, accountSnapShots, {
      responseType: 'json',
      params: {
        date: analysisDate,
        analysisPeriods: monthsLookback,
      },
      cancelToken,
    });
    return response.data;
  } catch {
    throw ERR_MSG;
  }
}

export interface PortfolioParams {
  currency?: string;
  portKey: string;
  positions: { cusip: string; weight: number }[];
}

export interface AccountSnapShot extends PortfolioParams {
  date?: string;
}
